import React from 'react';
import { DatePicker, Menu, Row, Col, Dropdown, Button } from 'antd';
import moment from 'moment-timezone';
import { DownOutlined, CalendarOutlined } from '@ant-design/icons';
import { getTimezoneAwareRanges } from '../../core/hooks/ByDateFilter';
const { RangePicker } = DatePicker;

const DatePickerField = ({
  defaultPickerValue,
  defaultValue,
  value,
  onChange,
  data,
  dropDownValue,
  setDropDownValue,
  setCustomDateRange,
  has6MonDisables = true,
  screens,
  timezone = 'UTC',
}) => {
  // Get timezone-aware ranges
  const ranges = getTimezoneAwareRanges(timezone);
  /**
   * 6 months lookback only
   */
  const disabledDates = (current) => {
    //Always disable dates that is beyond default range
    if (current >= defaultValue[1] || current <= defaultPickerValue[0]) {
      return true;
    }
    if (has6MonDisables) {
      const now = timezone === 'UTC' ? moment.utc() : moment.tz(timezone);
      const sixMonthsAgo = timezone === 'UTC'
        ? moment.utc().subtract(6, 'months')
        : moment.tz(timezone).subtract(6, 'months');
      if (current <= sixMonthsAgo) {
        return true;
      } else if (current >= now) {
        return true;
      } else {
        return false;
      }
    }
  };

  // sort them by desc dates

  const onHandleDropdown = (e) => {
    setDropDownValue(e.key);
    handleOnChange(ranges[e.key]);
  };

  const menuItems = Object.entries(ranges).map((r) => (
    <Menu.Item key={r[0]} icon={<CalendarOutlined />}>
      {r[0]}
    </Menu.Item>
  ));

  const handleOnChange = (v) => {
    const startMoment = timezone === 'UTC'
      ? moment.utc(v[0] || value[0])
      : moment.tz(v[0] || value[0], timezone);
    const endMoment = timezone === 'UTC'
      ? moment.utc(v[1] || value[1])
      : moment.tz(v[1] || value[1], timezone);

    const getSelectedStartDate = startMoment.unix();
    const getSelectedEndDate = endMoment.unix();

    //make sure to only have valid date ranges
    if (getSelectedStartDate <= getSelectedEndDate && getSelectedEndDate >= getSelectedStartDate) {
      // filter data to get only between range dates
      const getFilteredData = data.filter((obj) => {
        const objDate = obj.date;
        return objDate >= getSelectedStartDate && objDate <= getSelectedEndDate;
      });

      onChange({
        data: getFilteredData,
        dates: v,
      });
    }
  };

  return (
    <>
      <Row>
        <Col span="24">
          <RangePicker
            allowClear={false}
            popupClassName="chart-date-picker-dropdown"
            disabledDate={disabledDates}
            defaultPickerValue={defaultPickerValue}
            defaultValue={defaultValue}
            value={value}
            onChange={handleOnChange}
            style={{
              marginBottom: '0.4rem',
              width: screens && screens.xs === true ? '100%' : '',
              minWidth: '230px',
            }}
            onCalendarChange={(v) => {
              const startMoment = timezone === 'UTC'
                ? moment.utc(v[0] || value[0])
                : moment.tz(v[0] || value[0], timezone);
              const endMoment = timezone === 'UTC'
                ? moment.utc(v[1] || value[1])
                : moment.tz(v[1] || value[1], timezone);

              const getSelectedStartDate = startMoment.unix();
              const getSelectedEndDate = endMoment.unix();
              //make sure to only have valid date ranges
              if (
                getSelectedStartDate <= getSelectedEndDate &&
                getSelectedEndDate >= getSelectedStartDate
              ) {
                setCustomDateRange(v);
                setDropDownValue('Custom');
              }
            }}
          />
          <Dropdown
            overlay={<Menu onClick={onHandleDropdown}>{menuItems}</Menu>}
            style={{ marginBottom: '0.4rem' }}
          >
            <Button
              style={{
                marginBottom: '0.4rem',
                width: screens && screens.xs === true ? '100%' : '',
              }}
            >
              <CalendarOutlined />
              {dropDownValue} <DownOutlined />
            </Button>
          </Dropdown>
        </Col>
      </Row>
    </>
  );
};

export default DatePickerField;
